module.exports = __webpack_public_path__ + "img/衡阳中医院.94628adc.png";